import React from 'react';
import { EnrollmentDataEntry } from './EnrollmentOverview';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getFilteredRowModel,
	getSortedRowModel,
	RowData,
	SortingState,
	useReactTable,
	Table as __Table,
} from '@tanstack/react-table';
import { Table as BTable } from 'react-bootstrap';
import TableBody from '../../Components/TableBody';
import TableHeader from '../../Components/TableHeader';

type Props = {
	data: EnrollmentDataEntry[];
	columns: AccessorKeyColumnDef<EnrollmentDataEntry, unknown>[];
	handleRowClick: (row: RowData) => void;
};
const Table = ({ data, columns, handleRowClick }: Props) => {
	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'startDate',
			desc: true,
		},
	]);

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		onSortingChange: setSorting,
		enableGlobalFilter: true,
		state: {
			sorting,
		},
	});
	return (
		<BTable responsive hover size={'l'}>
			<TableHeader table={table as __Table<unknown>} />
			<TableBody table={table as __Table<unknown>} handleRowClick={handleRowClick} />
		</BTable>
	);
};
export default Table;
